import React from 'react';
import moment from 'moment';

const renderTableBody = (headers, data, checkbox, openDetails) => {
    const body = data.map((document, index) => {
        let bankStatus = 'N'
        let classbankStatus = ''
        switch (document.U_FMB_Bank_Status) {
            case 'N':
                bankStatus = 'Sin Procesar'
                break;
            case 'Y':
                classbankStatus = 'text-warning'
                bankStatus = 'Pago en Proceso'
                break;
            case 'C':
                classbankStatus = 'text-success'
                bankStatus = 'Pago conciliado'
                break;
            case 'E':
                classbankStatus = 'text-danger'
                bankStatus = 'Error en el pago'
                break;
        
            default:
                bankStatus = 'N/A'
                break;
        }
        return (
            <tr key={index}>
                <td className="sticky-column" >
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                </td>
                <td className={`${classbankStatus}`}>{bankStatus}</td>
                <td>{document?.DocNum ?? 'N/A'}</td>
                <td>{document?.CardCode ?? 'N/A'}</td>
                <td>{document?.CardName ?? 'N/A'}</td>
                <td>{document?.NumAtCard ?? 'Sin Folio'}</td>
                <td>{moment(document?.DocDate).format("MM-DD-YYYY") ?? 'N/A'}</td>
                <td>{Number(document?.DocTotal).toFixed(2) ?? 'N/A'}</td>
                <td>{document?.DocStatus ?? 'N/A'}</td>
                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                        onClick={() => openDetails(document)}
                        style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};



const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td>{headers[6].title}</td>}
            {headers[7].value && <td>{headers[7].title}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }
    body = renderTableBody(headers, data, checkbox, openDetails);
    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;
}
export const renderCitibanamex = (headers, data, checkbox, openDetails) => {
    return renderTable(headers, data, checkbox, openDetails);

}   